import { Box, Button, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';

interface Props {
  goToDashboard: (tenantFirstName: string) => void;
  tenantFirstName: string;
}

const PostConfirmationPage = ({ tenantFirstName = 'your tenant', goToDashboard }: Props) => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={() => goToDashboard(tenantFirstName)}
      header={
        <Box css={{ padding: 'token(spacing.sm) !important', textAlign: 'center' }}>
          <Heading level={3} textStyle="heading-xs">
            Payment setup
          </Heading>
        </Box>
      }
      body={
        <Box
          css={{
            display: 'grid',
            textAlign: 'center',
            gridTemplateRows: 'auto',
            gap: 'token(spacing.sm) !important',
            padding: 'token(spacing.lg) !important',
          }}
        >
          <Box>
            <Icon
              size="xl"
              css={{
                color: 'green.400',
              }}
            >
              <IconCheckmarkCircleFilled />
            </Icon>
          </Box>
          <Paragraph textStyle="body-lg-bold">Payments successfully set up</Paragraph>
          <Paragraph>
            We notified {tenantFirstName} that you&apos;re collecting payments online. You may also want to contact{' '}
            {tenantFirstName} directly.
          </Paragraph>
          <Paragraph>
            {tenantFirstName} won&apos;t need to re-enter details that you provided. Once they get set up and schedule
            their payments, you&apos;ll start receiving payments right into your bank account.
          </Paragraph>
        </Box>
      }
      footer={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <Button emphasis="filled" onClick={() => goToDashboard(tenantFirstName)}>
            Go to payments dashboard
          </Button>
        </Box>
      }
    />
  );
};

export default PostConfirmationPage;
